import React from 'react';
import styled from 'styled-components';
import { surface, borderSubtle, info, infoLight } from '../../tokens/colors';
import { radiusLg } from '../../tokens/radii';

interface CardProps {
  selected?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const StyledCard = styled.div<{ $selected: boolean; $clickable: boolean }>`
  background: ${surface};
  border-radius: ${radiusLg};
  border: ${({ $selected }) => $selected
    ? `0.5px solid ${info}`
    : `0.5px solid ${borderSubtle}`
  };
  box-shadow: ${({ $selected }) => $selected ? `0 0 0 3px ${infoLight}` : 'none'};
  padding: 16px 20px;
  cursor: ${({ $clickable }) => $clickable ? 'pointer' : 'default'};
  transition: border-color 0.1s, box-shadow 0.1s;
`;

export const Card: React.FC<CardProps> = ({ selected = false, children, onClick, style }) => (
  <StyledCard $selected={selected} $clickable={!!onClick} onClick={onClick} style={style}>
    {children}
  </StyledCard>
);
